import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MyinfoService } from '@services/myinfo.service';

@Component({
  selector: 'app-myinfo-redirection',
  templateUrl: './myinfo-redirection.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MyinfoRedirectionComponent implements OnInit{
  protected readonly myinfoService = inject(MyinfoService);
  protected readonly route = inject(ActivatedRoute);
  protected readonly router = inject(Router);
  isRedirecting: boolean = true;
  isApp: boolean = false;

  ngOnInit() {
    const userAgent = navigator.userAgent.toLowerCase();
    this.isApp = /(android|iphone|ipad|ipod|windows phone)/i.test(userAgent);
    console.log(userAgent);

    this.route.queryParams.subscribe(params => {
      const myinfoAuthUrl = params['url'];
      const state = params['state'];

      if(myinfoAuthUrl && state) {
        // new state item in chromesafaribrowser
        localStorage.setItem('myinfo_state', state);
        window.location = myinfoAuthUrl;
        return;
      }

      const authCode = params['code'];

      if(authCode) {
        this.isRedirecting = false;
        this.myinfoService.updateCodeReference({
          state: localStorage.getItem('myinfo_state')!,
          auth_code: authCode
        }).subscribe((result) => {
          if(!this.isApp) {
            if(result.purpose === 'registration') {
              this.router.navigate(['/auth/sign-up'], { queryParams: { code: authCode}});
            }else if(result.purpose === 'profile') {
              this.router.navigateByUrl('/account/edit-profile?tab=1&code='+authCode);
            }
          }
        });
      }
    });
  }
}
